import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ title, description, images, youtubeLink, role, url}) => {

  return (
    <div
      className="rounded-2xl mt-0 p-6 justify-center"
      >
      <div className="flex">
        <h3 className="text-xl font-bold mb-2 mr-2">Title:</h3>
              {url ? (<Link to={url} className="text-xl text-blue-500 underline font-medium mb-2">{title}</Link>) :
           (<p className="text-xl text-slate-900 font-medium mb-2">{title}</p> )}
      </div>

      <div className="flex">
        
        <p className="text-xl text-slate-900 font-medium mb-2">{description}</p>
      </div>

      <div className="flex">
        {images ? (<h3 className="text-xl font-bold mr-2 mb-1">Images:</h3>) : (<p></p>)}
      </div>

      <div className="flex gap-2">
        {images ? (images.map((src, index) => (
          <img key={index} src={src} alt={`Project ${index + 1}`} className="w-1/3 rounded-lg" />
        ))) : (<p>No Images Yet...</p>)}
      </div>

      <div className="flex gap-4">
        {youtubeLink ? (
          <a href={youtubeLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
            Watch using External Link
          </a>
        ) : (
          <p>Link Coming Soon</p>
        )}
      </div>
      
  {/*    <div className="flex">
        <h3 className="text-xl font-bold mr-2">Role:</h3>
        <p className="text-xl text-slate-900 font-medium mb-2">{role}</p>
          </div>
          <div className="border border-red-400"></div>*/}
    </div>
  );
};

export default ProjectCard;
